var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 467,
    width: 29,
    height: 28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    transform: "translate(-273 -467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 12.8333C22.1667 13.475 21.6417 14 21 14 20.3583 14 19.8333 13.475 19.8333 12.8333L19.8333 11.6667 19.25 5.83333 21.5833 5.83333 22.1667 11.6667 22.1667 12.8333ZM17.5 12.8333C17.5 13.475 16.975 14 16.3333 14 15.6917 14 15.1667 13.475 15.1667 12.8333L15.1667 11.6667 14.875 5.83333 17.2083 5.83333 17.5 11.6667 17.5 12.8333ZM12.8333 11.6667 12.8333 12.8333C12.8333 13.475 12.3083 14 11.6667 14 11.025 14 10.5 13.475 10.5 12.8333L10.5 11.6667 10.7917 5.83333 13.125 5.83333 12.8333 11.6667ZM11.6667 21 7 21 7 16.3333 11.6667 16.3333 11.6667 21ZM5.83333 12.8333 5.83333 11.6667 6.41667 5.83333 8.75 5.83333 8.16667 11.6667 8.16667 12.8333C8.16667 13.475 7.64167 14 7 14 6.35833 14 5.83333 13.475 5.83333 12.8333ZM23.3333 4.08333 4.66667 4.08333 3.5 11.6667 3.5 12.8333C3.5 13.475 4.025 14 4.66667 14L4.66667 23.9167 14.5833 23.9167 14.5833 16.3333 21 16.3333 21 23.9167 23.3333 23.9167 23.3333 14C23.975 14 24.5 13.475 24.5 12.8333L24.5 11.6667 23.3333 4.08333Z",
    fill: "current",
    transform: "matrix(1.03571 0 0 1 273 467)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCategory);
export default __webpack_public_path__ + "static/media/nav-category.73a4bb6912308b1da7597fb235cade3c.svg";
export { ForwardRef as ReactComponent };